import Header from '@components/Header';
import colors from '@constants/colors';
import SettingIcon from '@icons/setting/SettingLine';
import { useFlow } from '@stackflow/react';

function MyMenuHeader() {
    const { push } = useFlow();
    const handleSettingClick = () => {
        push('MyMenuSettingBottomSheet', {});
    };
    return (
        <Header title='MY메뉴 전체보기'
            trailing={<SettingIcon size={30}
                onClick={handleSettingClick}
                color={colors.gray9} />} />
    );
}

export default MyMenuHeader;
